import { render, staticRenderFns } from "./ResetearEvaluaciones.vue?vue&type=template&id=4a0b62a0"
import script from "./ResetearEvaluaciones.vue?vue&type=script&lang=js"
export * from "./ResetearEvaluaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports